// react-router v6 compatibility shim — exposes the v5 `{ history, match, location }`
// shape backed by v6 hooks. Once consumers migrate to useNavigate/useParams
// directly this can be removed (mirrors master's PLA-6641 plan).
import { useRouterCompat } from 'utils/withRouter';

const useRouter = () => useRouterCompat();

export default useRouter;
